export default __webpack_public_path__ + "static/media/travel.967b490c.png";